import { useContext } from 'react';
import { ImageSearchResultCard } from '@monash/portal-frontend-common';
import { SearchContextHoneycomb } from '@/components/providers/search-provider-honeycomb/SearchProviderHoneycomb';
import { getPrimaryUrl, resolveCategoryNames } from './utils';

const ImageSearchResultCardAdapter = ({
  entity,
  entityId,
  className,
  onLinkClick,
}) => {
  const { categories: allCategories } = useContext(SearchContextHoneycomb);

  const { linkType, name, description, displayLabel, categories, image } =
    entity ?? {};

  return (
    <div
      onClickCapture={() => {
        if (onLinkClick) {
          onLinkClick(entity, entityId);
        }
      }}
    >
      <ImageSearchResultCard
        linkType={linkType ?? 'link'}
        name={name}
        description={description}
        displayLabel={displayLabel}
        categoryNames={resolveCategoryNames(categories, allCategories)}
        url={getPrimaryUrl(entity)}
        imageUrl={image?.url}
        className={className}
      />
    </div>
  );
};

export default ImageSearchResultCardAdapter;
